var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"unavailable-label flex justify-center items-center gap-2.5 rounded-sm py-[3px] px-1 font-normal text-[9px]"},[_vm._v("\n  UNAVAILABLE\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }